module.exports = __webpack_public_path__ + "static/media/1POLICY7.8ade4bdb.jpg";